// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "disclaimer-2UdQW";
var _3 = "disclaimer__icon-XTF7s";
export { _1 as "__esModule", _2 as "disclaimer", _3 as "disclaimer__icon" }
export default { "__esModule": _1, "disclaimer": _2, "disclaimer__icon": _3 }
